import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../redux/features/auth/authThunks";
import { selectAgent } from "../../redux/features/agent/agentSelectors";

const Header = ({ headerText }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const agentInfo = useSelector(selectAgent);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const sidebarRef = useRef(null);
  const menuButtonRef = useRef(null);

  const isLoginPage = location.pathname === "/";

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const handleLogout = async () => {
    try {
      await dispatch(logoutUser());
      toggleSidebar();
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        menuButtonRef.current &&
        !menuButtonRef.current.contains(event.target)
      ) {
        setSidebarOpen(false);
      }
    };

    if (sidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen]);

  return (
    <div>
      <header className="relative flex items-center p-4 bg-white border-neutral-500">
        {/* Sidebar Toggle Icon */}
        <img
          ref={menuButtonRef}
          src={process.env.PUBLIC_URL + "/Images/menu.jpg"}
          alt="Menu"
          className="h-3 w-7 cursor-pointer mr-5"
          onClick={toggleSidebar}
        />

        {/* Logo */}
        <Link to="/main-page" className="text-lg font-medium">
          <img
            src="/Images/Logo.png"
            alt="OrderseazenPOS Logo"
            className="h-8 w-auto md:h-12 mr-2"
          />
        </Link>

        {/* Centered Header Text */}
        <h1 className="absolute left-1/2 transform -translate-x-1/2 text-xl font-bold text-gray-500 md:text-2xl whitespace-nowrap">
          {headerText}
        </h1>

        {/* Spacer for consistent layout */}
        <div className="ml-auto w-6 hidden md:block"></div>
      </header>

      {/* Sidebar Menu */}
      {!isLoginPage && (
        <div
          ref={sidebarRef}
          className={`fixed top-0 left-0 h-full bg-white border-r-2 border-neutral-500 z-[9999] shadow-lg transform transition-transform duration-300 ease-in-out ${
            sidebarOpen
              ? "translate-x-0 w-3/4 sm:w-1/2 md:w-1/3 lg:w-1/5"
              : "-translate-x-full"
          }`}
        >
          <div className="flex flex-col h-full p-5">
            {/* Sidebar Header */}
            <div className="flex justify-end">
              <button onClick={() => setSidebarOpen(false)} className="text-xl">
                &times;
              </button>
            </div>

            {/* Agent Info */}
            <div className="text-lg font-medium text-gray-700 mb-4">
              {agentInfo?.first_name} {agentInfo?.last_name}
            </div>

            {/* Sidebar Links */}
            <div className="flex flex-col space-y-4 text-black">
            <Link
                to="/main-page"
                className="text-lg font-medium hover:text-gray-700 transition"
              >
                &gt; Home
              </Link>
              {/* <Link
                to="/search"
                className="text-lg font-medium hover:text-gray-700 transition"
              >
                &gt; Place Order
              </Link> */}
              <Link
                to="/promocode"
                className="text-lg font-medium hover:text-gray-700 transition"
              >
                &gt; User Settings
              </Link>
            </div>

            {/* Logout Button */}
            <div className="mt-auto">
              <button
                onClick={handleLogout}
                className="bg-red-700 text-white rounded-xl w-full py-3"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
